import Manage from './manage'

export default [Manage]
